import {useMemo} from 'react';
import {useTemplate} from "../../../../../context/TemplateContext";
import {ImageInput, ImageValue} from "../../../../../models/Template";

export interface UsedByEntry {
    inputKey: string;
    label: string;
}

export type UsedAssetMap = Record<string, UsedByEntry[]>;

export function useUsedAssets(currentElementKey: string) {
    const {template, selections, selectedImageData} = useTemplate();

    return useMemo(() => {
        const usedAssetMap: UsedAssetMap = {};
        let hasSiblingInputs = false;

        if (!template?.inputs || !selectedImageData?.folderId) {
            return {usedAssetMap, hasSiblingInputs};
        }

        const currentFolderId = selectedImageData.folderId;

        // Find sibling image inputs that share the same folderId
        const siblingInputs = Object.entries(template.inputs).filter(
            ([key, input]) =>
                key !== currentElementKey &&
                input.type === 'image' &&
                (input as ImageInput).folderId === currentFolderId
        );

        hasSiblingInputs = siblingInputs.length > 0;

        for (const [key, input] of siblingInputs) {
            const selection = selections[key] as ImageValue | undefined;
            if (!selection?.thumbnail) continue;

            const thumb = selection.thumbnail;
            if (!usedAssetMap[thumb]) {
                usedAssetMap[thumb] = [];
            }
            usedAssetMap[thumb].push({
                inputKey: key,
                label: input.placeholder || key,
            });
        }

        return {usedAssetMap, hasSiblingInputs};
    }, [template, selections, selectedImageData, currentElementKey]);
}
